import {styled} from '@mui/system'

export const WarningPatientEmptyDataStyled = styled('div')(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '8px',
  justifyContent: 'center'
}))
